// import React, { useEffect, useState } from 'react';
// import { FaEdit, FaExternalLinkAlt, FaPlus, FaTrash } from 'react-icons/fa';
// import './FacultyList.css';
// import AddHod from "./AddHod.jsx";
// import AddFaculty from "./AddFaculty.jsx";
// import EditHodModal from "./EditHodModal.jsx";
// import EditFacultyModal from "./EditFacultyModal.jsx";
// import axios from 'axios';
// import { Base_Url } from '../config';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { setUserData } from '../redux/userSlice';
// import dummy from "../Assests/dummy.jpg"

// // Email Obfuscator Component
// const EmailObfuscator = ({ email }) => {
//   const [isRevealed, setIsRevealed] = useState(false);
  
//   const handleReveal = () => {
//     setIsRevealed(true);
//   };

//   return (
//     <span 
//       onClick={!isRevealed ? handleReveal : undefined}
//       style={{ 
//         cursor: !isRevealed ? 'pointer' : 'default',
//         // filter: !isRevealed ? 'blur(4px)' : 'none',
//         transition: 'filter 0.3s ease',
//         userSelect: 'text'
//       }}
//       title={!isRevealed ? " Click to reveal email" : ""}
//     >
//       {!isRevealed ? " Click to reveal email" :  email}
//     </span>
//   );
// };

// const FacultyMember = ({ statecsc, summary, staffuser, designation, id, name, title, email, phone, researchAreas, office, image, website, deleteFaculty, openEditModal2, facultstaff, userid, userfromwebmaster }) => ( 
//   <div className="faculty-card ">
//     <div className="faculty-card-header">
//       {
//         userfromwebmaster.userExists || statecsc.userState == 0 ? (
//           <FaTrash className="faculty-trash-icon text-danger" onClick={() => deleteFaculty(id)} />
//         ) : (
//           staffuser?.staffExists && staffuser?.staffData?.user_id == userid ? (
//             <>
//               <FaTrash className="faculty-trash-icon text-danger" onClick={() => deleteFaculty(id)} /> 
//             </>
//           ) : null
//         )
//       }
//       {
//         userfromwebmaster.userExists || statecsc.userState == 0 ? (
//           <FaEdit
//             className="ms-2 faculty-edit-icon text-success"
//             onClick={() => openEditModal2({ id, name, title, email, phone, summary, image, website, office, userid: userid, designation: designation, summary})}
//           />
//         ) : (
//           staffuser?.staffExists && staffuser?.staffData?.user_id == userid ? (
//             <>
//               <FaEdit
//                 className="ms-2 faculty-edit-icon text-success"
//                 onClick={() => openEditModal2({ id, name, title, email, phone, summary, image, website, office, userid: userid, designation: designation, summary})}
//               />
//             </>
//           ) : null
//         )
//       }
//     </div>
//     <img
//       className="faculty-image"
//       src={(image && image !== "") ? `${Base_Url}/${image}` : dummy}
//       alt={name}
//     />
//     <div className="faculty-info">
//       <h3 className="faculty-name">{name}</h3>
//       <p className="faculty-title">{title}</p>
//       <p className="faculty-title">{designation}</p>
//       <p className="faculty-email">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Email:</span> 
//         <EmailObfuscator email={email} />
//       </p>
//       <p className="faculty-phone">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Phone:</span> {phone}
//       </p>
//       <p className="faculty-research">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Work Summary:</span> {summary}
//       </p>
//       <div className="faculty-buttons">
//         {website && website.trim() !== "" && (
//           <a
//             className="faculty-button"
//             href={website}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Webpage <FaExternalLinkAlt />
//           </a>
//         )}
//         <Link to={`/people/${id}`} className="faculty-button" target="_blank" rel="noopener noreferrer">
//           Profile <FaExternalLinkAlt />
//         </Link>
//       </div>
//     </div>
//   </div>
// );

// const Faculty = () => {
//   const [modal, setModal] = useState(false);
//   const [modal2, setModal2] = useState(false);
//   const [hod, setHod] = useState([]);
//   const [editModal, setEditModal] = useState(false);
//   const [editModal2, setEditModal2] = useState(false);
//   const [editFacultyByFaculty, setEditFacultyByFaculty] = useState(false);
//   const [editObj, setEditObj] = useState(null);
//   const [editObj2, setEditObj2] = useState(null);
//   const userfromwebmaster = useSelector((state) => state.user);
//   const facultstaff = useSelector((state) => state.facultyuser);

//   const [srSysManager, setSrSysManager] = useState([]);
//   const [head, setHead] = useState([]);
//   const [allStaff, setAllStaff] = useState([]);
//   const [sysManager, setSystemManager] = useState([]);
//   const [sysArchitect, setSysArchitect] = useState([]);

  
//   const addHod = () => setModal(true);
//   const closeModal = () => setModal(false);

//   const addFaculty = () => setModal2(true);
//   const closeModal2 = () => setModal2(false);

//   const fetchHod = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/hod`);
//       setHod(response.data);
//     } catch (error) {
//       console.error(error.message);
//     }
//   };



//   const fetchFaculty = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/profiles`);
//       const data = response.data;

//       const filteredData = data.filter(person =>
//         person.show_in_display === 1 && person.isretired === 0
//       );

//       const headPerson = filteredData.filter(person =>
//         person.show_hod === 1
//       );

//       const srSysManagers = filteredData.filter(person =>
//         person.designation === 'Sr. System Manager (SG)'
//       );

//       const systemManagers = filteredData.filter(person =>
//         person.designation === 'System Manager'
//       );

//       const sysArchitects = filteredData.filter(person =>
//         person.designation === 'System Architect'
//       );

//       const staff = filteredData.filter(person =>
//         !['Sr. System Manager (SG)', 'System Manager', 'System Architect' ,'Professor'].includes(person.designation)
//       );

//       setHead(headPerson);
//       setSrSysManager(srSysManagers);
//       setSystemManager(systemManagers);
//       setSysArchitect(sysArchitects);

//       // Only show staff who are NOT outsourced (0/false) AND NOT ird (0/false)
//       let staffper = staff.filter(person => 
//          (person.technicalstaff === true || person.technicalstaff === 1)
//       );
      
//       setAllStaff(staffper);

//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   const deleteHod = async (id) => {
//     if (window.confirm("Are you sure you want to delete this People?")) {
//       try {
//         await axios.delete(`${Base_Url}/profiles/${id}`);
//         setHod(hod.filter(item => item.id !== id));
//       } catch (error) {
//         console.error(error.message);
//       }
//     }
//   };

//   const deleteFaculty = async (id) => {
//     if (window.confirm("Are you sure you want to delete this Faculty member?")) {
//       try {
//         await axios.delete(`${Base_Url}/profile/${id}`);
//       } catch (error) {
//         console.error(error.message);
//       }
//     }
//   };

//   const openEditModal = (hod) => {
//     setEditObj(hod);
//     setEditModal(true);
//   };

//   const closeEditModal = () => {
//     setEditModal(false);
//     setEditObj(null);
//   };

//   const openEditModal2 = (faculty) => {
//     setEditObj2(faculty);
//     setEditModal2(true);
//   };

//   const closeEditModal2 = () => {
//     setEditModal2(false);
//     setEditObj2(null);
//   };

//   useEffect(() => {
//     fetchFaculty();
//   }, []);

//   const statecsc = useSelector((state) => state.statecsc)
//   const staffuser = useSelector((state) => state.staffuser)



//   return (
//     <>
//       <AddHod modal={modal} closeModal={closeModal} fetchHod={fetchHod} />
//       <AddFaculty modal={modal2} closeModal={closeModal2} fetchFaculty={fetchFaculty} />
//       <EditHodModal
//         modal={editModal}
//         closeModal={closeEditModal}
//         editObj={editObj}
//         fetchHod={fetchHod}
//       />
//       <EditFacultyModal
//         modal={editModal2}
//         closeModal={closeEditModal2}
//         editObj={editObj2}
//         fetchFaculty={fetchFaculty}
//       />
//       <div className="faculty-container">
//         <div className='d-flex justify-content-center align-items-center'>
//          <h2 className="page-title mb-4 border-bottom-0 mt-lg-4 mb-0 pb-0">
//              Technical <span className="highlight-title">Staff</span>
//            </h2>
//           {
//             userfromwebmaster.userExists || statecsc.userState == 0 ? <>
//               <FaPlus onClick={addFaculty} className='ms-2 text-primary mt-2' />
//             </> : ""
//           }
//         </div>
//         <div className="row">
//           {allStaff.length > 0 && allStaff?.sort((a, b) => a?.name?.localeCompare(b.name))?.map((elem, index) => (
//             <div key={elem.id} className="col-md-6 mb-4">
//               <FacultyMember
//                 facultstaff={facultstaff}
//                 userfromwebmaster={userfromwebmaster}
//                 id={elem.id}
//                 userid={elem.userid}
//                 office={elem.office}
//                 designation={elem.designation}
//                 name={elem.name}
//                 staffuser={staffuser}
//                 statecsc={statecsc}
//                 title={elem.title}
//                 email={elem.email}
//                 phone={elem.phone}
//                 summary={elem.summary}
//                 image={elem.image_path}
//                 website={elem.weblink}
//                 deleteFaculty={deleteFaculty}
//                 openEditModal2={openEditModal2}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Faculty;



// import React, { useEffect, useState } from 'react';
// import { FaEdit, FaExternalLinkAlt, FaPlus, FaTrash } from 'react-icons/fa';
// import './FacultyList.css';
// import AddHod from "./AddHod.jsx";
// import AddFaculty from "./AddFaculty.jsx";
// import EditHodModal from "./EditHodModal.jsx";
// import EditFacultyModal from "./EditFacultyModal.jsx";
// import axios from 'axios';
// import { Base_Url } from '../config';
// import { Link } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { setUserData } from '../redux/userSlice';
// import dummy from "../Assests/dummy.jpg"

// // Email Obfuscator Component
// const EmailObfuscator = ({ email }) => {
//   const [isRevealed, setIsRevealed] = useState(false);
  
//   const handleReveal = () => {
//     setIsRevealed(true);
//   };

//   return (
//     <span 
//       onClick={!isRevealed ? handleReveal : undefined}
//       style={{ 
//         cursor: !isRevealed ? 'pointer' : 'default',
//         // filter: !isRevealed ? 'blur(4px)' : 'none',
//         transition: 'filter 0.3s ease',
//         userSelect: 'text'
//       }}
//       title={!isRevealed ? " Click to reveal email" : ""}
//     >
//       {!isRevealed ? " Click to reveal email" :  email}
//     </span>
//   );
// };

// const FacultyMember = ({ statecsc, summary, staffuser, designation, id, name, title, email, phone, researchAreas, office, image, website, deleteFaculty, openEditModal2, facultstaff, userid, userfromwebmaster }) => ( 
//   <div className="faculty-card ">
//     <div className="faculty-card-header">
//       {
//         userfromwebmaster.userExists || statecsc.userState == 0 ? (
//           <FaTrash className="faculty-trash-icon text-danger" onClick={() => deleteFaculty(id)} />
//         ) : (
//           staffuser?.staffExists && staffuser?.staffData?.user_id == userid ? (
//             <>
//               <FaTrash className="faculty-trash-icon text-danger" onClick={() => deleteFaculty(id)} /> 
//             </>
//           ) : null
//         )
//       }
//       {
//         userfromwebmaster.userExists || statecsc.userState == 0 ? (
//           <FaEdit
//             className="ms-2 faculty-edit-icon text-success"
//             onClick={() => openEditModal2({ id, name, title, email, phone, summary, image, website, office, userid: userid, designation: designation, summary})}
//           />
//         ) : (
//           staffuser?.staffExists && staffuser?.staffData?.user_id == userid ? (
//             <>
//               <FaEdit
//                 className="ms-2 faculty-edit-icon text-success"
//                 onClick={() => openEditModal2({ id, name, title, email, phone, summary, image, website, office, userid: userid, designation: designation, summary})}
//               />
//             </>
//           ) : null
//         )
//       }
//     </div>
//     <img
//       className="faculty-image"
//       src={(image && image !== "") ? `${Base_Url}/${image}` : dummy}
//       alt={name}
//     />
//     <div className="faculty-info">
//       <h3 className="faculty-name">{name}</h3>
//       <p className="faculty-title">{title}</p>
//       <p className="faculty-title">{designation}</p>
//       <p className="faculty-email">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Email:</span> 
//         <EmailObfuscator email={email} />
//       </p>
//       <p className="faculty-phone">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Phone:</span> {phone}
//       </p>
//       <p className="faculty-research">
//         <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Work Summary:</span> {summary}
//       </p>
//       <div className="faculty-buttons">
//         {website && website.trim() !== "" && (
//           <a
//             className="faculty-button"
//             href={website}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Webpage <FaExternalLinkAlt />
//           </a>
//         )}
//         <Link to={`/people/${id}`} className="faculty-button" target="_blank" rel="noopener noreferrer">
//           Profile <FaExternalLinkAlt />
//         </Link>
//       </div>
//     </div>
//   </div>
// );

// const Faculty = () => {
//   const [modal, setModal] = useState(false);
//   const [modal2, setModal2] = useState(false);
//   const [hod, setHod] = useState([]);
//   const [editModal, setEditModal] = useState(false);
//   const [editModal2, setEditModal2] = useState(false);
//   const [editFacultyByFaculty, setEditFacultyByFaculty] = useState(false);
//   const [editObj, setEditObj] = useState(null);
//   const [editObj2, setEditObj2] = useState(null);
//   const userfromwebmaster = useSelector((state) => state.user);
//   const facultstaff = useSelector((state) => state.facultyuser);

//   const [srSysManager, setSrSysManager] = useState([]);
//   const [head, setHead] = useState([]);
//   const [allStaff, setAllStaff] = useState([]);
//   const [sysManager, setSystemManager] = useState([]);
//   const [sysArchitect, setSysArchitect] = useState([]);
//   const [technicalStaff, setTechnicalStaff] = useState([]); // NEW STATE FOR TECHNICAL STAFF
//   const [nonTechnicalStaff, setNonTechnicalStaff] = useState([]); // NEW STATE FOR NON-TECHNICAL STAFF

  
//   const addHod = () => setModal(true);
//   const closeModal = () => setModal(false);

//   const addFaculty = () => setModal2(true);
//   const closeModal2 = () => setModal2(false);

//   const fetchHod = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/hod`);
//       setHod(response.data);
//     } catch (error) {
//       console.error(error.message);
//     }
//   };

//   const fetchFaculty = async () => {
//     try {
//       const response = await axios.get(`${Base_Url}/profiles`);
//       const data = response.data;

//       const filteredData = data.filter(person =>
//         person.show_in_display === 1 && person.isretired === 0
//       );

//       const headPerson = filteredData.filter(person =>
//         person.show_hod === 1
//       );

//       const srSysManagers = filteredData.filter(person =>
//         person.designation === 'Sr. System Manager (SG)'
//       );

//       const systemManagers = filteredData.filter(person =>
//         person.designation === 'System Manager'
//       );

//       const sysArchitects = filteredData.filter(person =>
//         person.designation === 'System Architect'
//       );

//       const staff = filteredData.filter(person =>
//         !['Sr. System Manager (SG)', 'System Manager', 'System Architect' ,'Professor'].includes(person.designation)
//       );

//       setHead(headPerson);
//       setSrSysManager(srSysManagers);
//       setSystemManager(systemManagers);
//       setSysArchitect(sysArchitects);

//       // SEPARATE TECHNICAL AND NON-TECHNICAL STAFF
//       const technicalStaff = staff.filter(person => 
//          (person.technicalstaff === true || person.technicalstaff === 1) &&
//         (person.outsource === false || person.outsource === 0) && 
//         (person.ird === false || person.ird === 0)
//       );
      
//       const nonTechnicalStaff = staff.filter(person => 
//         (person.technicalstaff === false || person.technicalstaff === 0) &&
//         (person.outsource === false || person.outsource === 0) && 
//         (person.ird === false || person.ird === 0)
//       );
      
//       setTechnicalStaff(technicalStaff);
//       setNonTechnicalStaff(nonTechnicalStaff);

//     } catch (error) {
//       console.error('Error fetching data:', error);
//     }
//   };

//   const deleteHod = async (id) => {
//     if (window.confirm("Are you sure you want to delete this People?")) {
//       try {
//         await axios.delete(`${Base_Url}/profiles/${id}`);
//         setHod(hod.filter(item => item.id !== id));
//       } catch (error) {
//         console.error(error.message);
//       }
//     }
//   };

//   const deleteFaculty = async (id) => {
//     if (window.confirm("Are you sure you want to delete this Faculty member?")) {
//       try {
//         await axios.delete(`${Base_Url}/profile/${id}`);
//       } catch (error) {
//         console.error(error.message);
//       }
//     }
//   };

//   const openEditModal = (hod) => {
//     setEditObj(hod);
//     setEditModal(true);
//   };

//   const closeEditModal = () => {
//     setEditModal(false);
//     setEditObj(null);
//   };

//   const openEditModal2 = (faculty) => {
//     setEditObj2(faculty);
//     setEditModal2(true);
//   };

//   const closeEditModal2 = () => {
//     setEditModal2(false);
//     setEditObj2(null);
//   };

//   useEffect(() => {
//     fetchFaculty();
//   }, []);

//   const statecsc = useSelector((state) => state.statecsc)
//   const staffuser = useSelector((state) => state.staffuser)

//   return (
//     <>
//       <AddHod modal={modal} closeModal={closeModal} fetchHod={fetchHod} />
//       <AddFaculty modal={modal2} closeModal={closeModal2} fetchFaculty={fetchFaculty} />
//       <EditHodModal
//         modal={editModal}
//         closeModal={closeEditModal}
//         editObj={editObj}
//         fetchHod={fetchHod}
//       />
//       <EditFacultyModal
//         modal={editModal2}
//         closeModal={closeEditModal2}
//         editObj={editObj2}
//         fetchFaculty={fetchFaculty}
//       />
      
//       {/* TECHNICAL STAFF SECTION */}
//       <div className="faculty-container">
//         <div className='d-flex justify-content-center align-items-center mt-lg-3'>
//           <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//             Technical <span className="highlight-title">Staff</span>
//           </h2>
//           {
//             userfromwebmaster.userExists || statecsc.userState == 0 ? <>
//               <FaPlus onClick={addFaculty} className='ms-2 text-primary mt-2' />
//             </> : ""
//           }
//         </div>
//         <div className="row">
//           {technicalStaff.length > 0 && technicalStaff?.sort((a, b) => a?.name?.localeCompare(b.name))?.map((elem, index) => (
//             <div key={elem.id} className="col-md-6 mb-4">
//               <FacultyMember
//                 facultstaff={facultstaff}
//                 userfromwebmaster={userfromwebmaster}
//                 id={elem.id}
//                 userid={elem.userid}
//                 office={elem.office}
//                 designation={elem.designation}
//                 name={elem.name}
//                 staffuser={staffuser}
//                 statecsc={statecsc}
//                 title={elem.title}
//                 email={elem.email}
//                 phone={elem.phone}
//                 summary={elem.summary}
//                 image={elem.image_path}
//                 website={elem.weblink}
//                 deleteFaculty={deleteFaculty}
//                 openEditModal2={openEditModal2}
//               />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* NON-TECHNICAL STAFF SECTION */}
//       <div className="faculty-container mt-5">
//         <div className='d-flex justify-content-center align-items-center'>
//           <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//             Non-Technical <span className="highlight-title">Staff</span>
//           </h2>
//           {
//             userfromwebmaster.userExists || statecsc.userState == 0 ? <>
//               <FaPlus onClick={addFaculty} className='ms-2 text-primary mt-2' />
//             </> : ""
//           }
//         </div>
//         <div className="row">
//           {nonTechnicalStaff.length > 0 && nonTechnicalStaff?.sort((a, b) => a?.name?.localeCompare(b.name))?.map((elem, index) => (
//             <div key={elem.id} className="col-md-6 mb-4">
//               <FacultyMember
//                 facultstaff={facultstaff}
//                 userfromwebmaster={userfromwebmaster}
//                 id={elem.id}
//                 userid={elem.userid}
//                 office={elem.office}
//                 designation={elem.designation}
//                 name={elem.name}
//                 staffuser={staffuser}
//                 statecsc={statecsc}
//                 title={elem.title}
//                 email={elem.email}
//                 phone={elem.phone}
//                 summary={elem.summary}
//                 image={elem.image_path}
//                 website={elem.weblink}
//                 deleteFaculty={deleteFaculty}
//                 openEditModal2={openEditModal2}
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Faculty;

import React, { useEffect, useState } from 'react';
import { FaEdit, FaExternalLinkAlt, FaPlus, FaTrash } from 'react-icons/fa';
import './FacultyList.css';
import AddHod from "./AddHod.jsx";
import AddFaculty from "./AddFaculty.jsx";
import EditHodModal from "./EditHodModal.jsx";
import EditFacultyModal from "./EditFacultyModal.jsx";
import axios from 'axios';
import { Base_Url } from '../config';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData } from '../redux/userSlice';
import dummy from "../Assests/dummy.jpg"

// Email Obfuscator Component
const EmailObfuscator = ({ email }) => {
  const [isRevealed, setIsRevealed] = useState(false);
  
  const handleReveal = () => {
    setIsRevealed(true);
  };

  return (
    <span 
      onClick={!isRevealed ? handleReveal : undefined}
      style={{ 
        cursor: !isRevealed ? 'pointer' : 'default',
        // filter: !isRevealed ? 'blur(4px)' : 'none',
        transition: 'filter 0.3s ease',
        userSelect: 'text'
      }}
      title={!isRevealed ? " Click to reveal email" : ""}
    >
      {!isRevealed ? " Click to reveal email" :  email}
    </span>
  );
};

const FacultyMember = ({ statecsc, summary, staffuser, designation, id, name, title, email, phone, researchAreas, office, image, website, deleteFaculty, openEditModal2, facultstaff, userid, userfromwebmaster }) => ( 
  <div className="faculty-card ">
    <div className="faculty-card-header">
      {
        userfromwebmaster.userExists || statecsc.userState == 0 ? (
          <FaTrash className="faculty-trash-icon text-danger" onClick={() => deleteFaculty(id)} />
        ) : (
          staffuser?.staffExists && staffuser?.staffData?.user_id == userid ? (
            <>
              <FaTrash className="faculty-trash-icon text-danger" onClick={() => deleteFaculty(id)} /> 
            </>
          ) : null
        )
      }
      {
        userfromwebmaster.userExists || statecsc.userState == 0 ? (
          <FaEdit
            className="ms-2 faculty-edit-icon text-success"
            onClick={() => openEditModal2({ id, name, title, email, phone, summary, image, website, office, userid: userid, designation: designation, summary})}
          />
        ) : (
          staffuser?.staffExists && staffuser?.staffData?.user_id == userid ? (
            <>
              <FaEdit
                className="ms-2 faculty-edit-icon text-success"
                onClick={() => openEditModal2({ id, name, title, email, phone, summary, image, website, office, userid: userid, designation: designation, summary})}
              />
            </>
          ) : null
        )
      }
    </div>
    <img
      className="faculty-image"
      src={(image && image !== "") ? `${Base_Url}/${image}` : dummy}
      alt={name}
    />
    <div className="faculty-info">
      <h3 className="faculty-name">{name}</h3>
      <p className="faculty-title">{title}</p>
      <p className="faculty-title">{designation}</p>
      <p className="faculty-email">
        <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Email:</span> 
        <EmailObfuscator email={email} />
      </p>
      <p className="faculty-phone">
        <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Phone:</span> {phone}
      </p>
      <p className="faculty-research">
        <span className="faculty-phone-span" style={{ fontWeight: "600", color: "#555" }}>Work Summary:</span> {summary}
      </p>
      <div className="faculty-buttons">
        {website && website.trim() !== "" && (
          <a
            className="faculty-button"
            href={website}
            target="_blank"
            rel="noopener noreferrer"
          >
            Webpage <FaExternalLinkAlt />
          </a>
        )}
        <Link to={`/people/${id}`} className="faculty-button" target="_blank" rel="noopener noreferrer">
          Profile <FaExternalLinkAlt />
        </Link>
      </div>
    </div>
  </div>
);

const Faculty = () => {
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [hod, setHod] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [editModal2, setEditModal2] = useState(false);
  const [editFacultyByFaculty, setEditFacultyByFaculty] = useState(false);
  const [editObj, setEditObj] = useState(null);
  const [editObj2, setEditObj2] = useState(null);
  const userfromwebmaster = useSelector((state) => state.user);
  const facultstaff = useSelector((state) => state.facultyuser);

  const [srSysManager, setSrSysManager] = useState([]);
  const [head, setHead] = useState([]);
  const [allStaff, setAllStaff] = useState([]);
  const [sysManager, setSystemManager] = useState([]);
  const [sysArchitect, setSysArchitect] = useState([]);

  
  const addHod = () => setModal(true);
  const closeModal = () => setModal(false);

  const addFaculty = () => setModal2(true);
  const closeModal2 = () => setModal2(false);

  const fetchHod = async () => {
    try {
      const response = await axios.get(`${Base_Url}/hod`);
      setHod(response.data);
    } catch (error) {
      console.error(error.message);
    }
  };



  const fetchFaculty = async () => {
    try {
      const response = await axios.get(`${Base_Url}/profiles`);
      const data = response.data;

      const filteredData = data.filter(person =>
        person.show_in_display === 1 && person.isretired === 0
      );

      const headPerson = filteredData.filter(person =>
        person.show_hod === 1
      );

      const srSysManagers = filteredData.filter(person =>
        person.designation === 'Sr. System Manager (SG)'
      );

      const systemManagers = filteredData.filter(person =>
        person.designation === 'System Manager'
      );

      const sysArchitects = filteredData.filter(person =>
        person.designation === 'System Architect'
      );

      const staff = filteredData.filter(person =>
        !['Sr. System Manager (SG)', 'System Manager', 'System Architect' ,'Professor'].includes(person.designation)
      );

      setHead(headPerson);
      setSrSysManager(srSysManagers);
      setSystemManager(systemManagers);
      setSysArchitect(sysArchitects);

      // Only show staff who are NOT outsourced (0/false) AND NOT ird (0/false)
      let staffper = staff.filter(person => 
         (person.technicalstaff === true || person.technicalstaff === 1)
      );
      
      // Sort staff by order field, then by name
      const sortedStaff = staffper.sort((a, b) => {
        // Convert order to number, default to 0 if null/undefined
        const orderA = parseInt(a.order) || 0;
        const orderB = parseInt(b.order) || 0;
        
        // First sort by order
        if (orderA !== orderB) {
          return orderA - orderB;
        }
        
        // If order is the same, sort by name
        return a.name.localeCompare(b.name);
      });
      
      setAllStaff(sortedStaff);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const deleteHod = async (id) => {
    if (window.confirm("Are you sure you want to delete this People?")) {
      try {
        await axios.delete(`${Base_Url}/profiles/${id}`);
        setHod(hod.filter(item => item.id !== id));
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const deleteFaculty = async (id) => {
    if (window.confirm("Are you sure you want to delete this Faculty member?")) {
      try {
        await axios.delete(`${Base_Url}/profile/${id}`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const openEditModal = (hod) => {
    setEditObj(hod);
    setEditModal(true);
  };

  const closeEditModal = () => {
    setEditModal(false);
    setEditObj(null);
  };

  const openEditModal2 = (faculty) => {
    setEditObj2(faculty);
    setEditModal2(true);
  };

  const closeEditModal2 = () => {
    setEditModal2(false);
    setEditObj2(null);
  };

  useEffect(() => {
    fetchFaculty();
  }, []);

  const statecsc = useSelector((state) => state.statecsc)
  const staffuser = useSelector((state) => state.staffuser)



  return (
    <>
      <AddHod modal={modal} closeModal={closeModal} fetchHod={fetchHod} />
      <AddFaculty modal={modal2} closeModal={closeModal2} fetchFaculty={fetchFaculty} />
      <EditHodModal
        modal={editModal}
        closeModal={closeEditModal}
        editObj={editObj}
        fetchHod={fetchHod}
      />
      <EditFacultyModal
        modal={editModal2}
        closeModal={closeEditModal2}
        editObj={editObj2}
        fetchFaculty={fetchFaculty}
      />
      <div className="faculty-container">
        <div className='d-flex justify-content-center align-items-center'>
         <h2 className="page-title mb-4 border-bottom-0 mt-lg-4 mb-0 pb-0">
             Technical <span className="highlight-title">Staff</span>
           </h2>
          {
            userfromwebmaster.userExists || statecsc.userState == 0 ? <>
              <FaPlus onClick={addFaculty} className='ms-2 text-primary mt-2' />
            </> : ""
          }
        </div>
        <div className="row">
          {allStaff.length > 0 && allStaff.map((elem, index) => (
            <div key={elem.id} className="col-md-6 mb-4">
              <FacultyMember
                facultstaff={facultstaff}
                userfromwebmaster={userfromwebmaster}
                id={elem.id}
                userid={elem.userid}
                office={elem.office}
                designation={elem.designation}
                name={elem.name}
                staffuser={staffuser}
                statecsc={statecsc}
                title={elem.title}
                email={elem.email}
                phone={elem.phone}
                summary={elem.summary}
                image={elem.image_path}
                website={elem.weblink}
                deleteFaculty={deleteFaculty}
                openEditModal2={openEditModal2}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Faculty;